import { useRef } from 'react'
import type { CSSProperties } from 'react'

import './landing.css'

import { brand, fonts } from './brand'
import { ChannelsSection } from './sections/ChannelsSection'
import { ControlSection } from './sections/ControlSection'
import { FaqSection } from './sections/FaqSection'
import { FeatureRows } from './sections/FeatureRows'
import { FinalCta } from './sections/FinalCta'
import { HowItWorks } from './sections/HowItWorks'
import { LandingFooter } from './sections/LandingFooter'
import { LandingHeader } from './sections/LandingHeader'
import { LandingHero } from './sections/LandingHero'
import { PricingSection } from './sections/PricingSection'
import { ProductHighlights } from './sections/ProductHighlights'
import { useRevealOnScroll } from './useRevealOnScroll'

// Fundo/cor/tipografia base da pagina, equivalentes ao `body` de
// docs/design/prototype/Landing v2.dc.html — as secoes sem fundo proprio (produto, como,
// canais, duvidas) dependem desse pano de fundo para bater com o design.
const pageStyle: CSSProperties = {
  overflowX: 'hidden',
  background: brand.canvas,
  color: brand.ink,
  fontFamily: fonts.body,
  WebkitFontSmoothing: 'antialiased',
}

/**
 * Landing publica em `/`, implementada a partir de docs/design/prototype/Landing v2.dc.html
 * (config default: heroTheme='Noturno', heroFocus='Conversa ao vivo', motionLevel='Cinemático').
 * Fonte de verdade dos textos: src/lib/i18n/locales — nenhuma copy fica hardcoded aqui.
 */
export function LandingPage() {
  const containerRef = useRef<HTMLDivElement>(null)
  useRevealOnScroll(containerRef)

  return (
    <div ref={containerRef} className="landing-page" style={pageStyle}>
      <LandingHeader />
      <main>
        <LandingHero />
        <ProductHighlights />
        <HowItWorks />
        <FeatureRows />
        <ControlSection />
        <ChannelsSection />
        <PricingSection />
        <FaqSection />
        <FinalCta />
      </main>
      <LandingFooter />
    </div>
  )
}
